import * as React from 'react';
const SvgSlash = (props) => (React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "M2.16 4.287a.75.75 0 0 1 1.053-.127l18.5 14.5a.75.75 0 0 1-.926 1.18l-18.5-14.5a.75.75 0 0 1-.127-1.053Z", fill: "currentColor" })));
export default SvgSlash;
